import React from 'react';

const ExceedYourProfessionalGoalsSection = () => {
    return (
        <p>
            Use our #jobs channel on Discord to find your next opportunity. Join our CFP working
            group to have experienced speakers review your conference proposal. Learn new technical
            skills at our meetup, and level up in your career. With support from the WNB.rb
            community, you can set more ambitious goals than ever before!
        </p>
    );
};

export default ExceedYourProfessionalGoalsSection;
